export const KeyCode = {
    BACKSPACE: 'Backspace',
    ENTER: 'Enter',
    TAB: 'Tab',
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#whitespace_keys
    SPACE: 'Space',
    SPACEBAR: ' ',
    SPACEBAR_OLD: 'Spacebar',
    ESCAPE: 'Escape',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',

    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',

    SHIFT: 'Shift',

    HOME: 'Home',
    END: 'End',
};
